const A = "https://customer-assets.emergentagent.com/job_hampton-redesign/artifacts";

const IMAGES = {
  totalPillow: `${A}/30d729rk_TotalPillow.png`,
  twinDraftGuard: `${A}/gm9b4i99_TwinDraftGuard.png`,
  furnitureFix: `${A}/gc4vxygc_FurnitureFix.png`,
  thermalSocks: `${A}/b0pytk05_35%20Below.jpg`,
  saniSticks: `${A}/0mu3nkpc_SaniSticks.png`,
};

export const PRODUCTS = [
  {
    id: "total-pillow",
    name: "Total Pillow",
    category: "Home Comfort",
    tagline: "The versatile pillow that bends to your body.",
    description:
      "A patented, easy-adjust circular pillow that twists and molds to support your neck, back, knees or lumbar. Multi-support comfort, perfect for travel.",
    badge: "Best Seller",
    image: IMAGES.totalPillow,
  },
  {
    id: "twin-draft-guard",
    name: "Twin Draft Guard",
    category: "Home Efficiency",
    tagline: "Block drafts. Cut energy bills.",
    description:
      "A double-sided draft blocker that seals the gap under any door or window — cold air stays out, heat stays in, all season long.",
    badge: "Energy Saver",
    image: IMAGES.twinDraftGuard,
  },
  {
    id: "furniture-fix",
    name: "Furniture Fix",
    category: "Home Repair",
    tagline: "Lift & fix sagging chairs & sofas.",
    description:
      "Sturdy seat & cushion support panels slide under worn cushions to instantly eliminate sagging and sinking. Make your old sofa feel brand new.",
    badge: "Quick Fix",
    image: IMAGES.furnitureFix,
  },
  {
    id: "thermal-socks",
    name: "35° Below Thermal Socks",
    category: "Cold Weather",
    tagline: "Super warm, aluminized thermal insulation.",
    description:
      "Thermal insulated socks with aluminized fibers that trap and reflect body heat. Super warm and comfortable for outdoors, camping, hiking and winter sports.",
    badge: "As Seen on TV",
    image: IMAGES.thermalSocks,
  },
  {
    id: "sani-sticks",
    name: "Sani Sticks",
    category: "Home Care",
    tagline: "Prevent drain clogs & eliminate odors.",
    description:
      "Enzyme cleaning-action sticks that keep kitchen, bath and shower drains clog-free and fresh. Septic safe, phosphate free — lemon fresh scent.",
    badge: "Fan Favorite",
    image: IMAGES.saniSticks,
  },
];

export const CATEGORIES = [
  {
    id: "home-comfort",
    name: "Home Comfort",
    blurb: "Pillows, supports & cozy living essentials.",
    image: IMAGES.totalPillow,
  },
  {
    id: "home-efficiency",
    name: "Home Efficiency",
    blurb: "Save energy and money, season after season.",
    image: IMAGES.twinDraftGuard,
  },
  {
    id: "home-repair",
    name: "Home Repair",
    blurb: "Clever fixes for everyday household problems.",
    image: IMAGES.furnitureFix,
  },
  {
    id: "cold-weather",
    name: "Cold Weather",
    blurb: "Stay warm wherever winter takes you.",
    image: IMAGES.thermalSocks,
  },
  {
    id: "home-care",
    name: "Home Care",
    blurb: "Keep every room clean, fresh and clog-free.",
    image: IMAGES.saniSticks,
  },
];

export const HERO_SLIDES = [
  {
    id: "total-pillow",
    eyebrow: "As Seen on TV",
    title: "Total Pillow",
    subtitle: "Comfort that bends to you",
    description:
      "The patented, twistable support pillow that adapts to your neck, back and knees — relief, anywhere you need it.",
    image: IMAGES.totalPillow,
  },
  {
    id: "twin-draft-guard",
    eyebrow: "Home Efficiency",
    title: "Twin Draft Guard",
    subtitle: "Keep the cold out, the heat in",
    description:
      "The double-sided draft blocker that seals drafts from doors and windows — and helps cut your heating and cooling bills.",
    image: IMAGES.twinDraftGuard,
  },
  {
    id: "thermal-socks",
    eyebrow: "Stay Warm",
    title: "35° Below Thermal Socks",
    subtitle: "Aluminized warmth that lasts",
    description:
      "Super-warm thermal insulated socks with aluminized fibers that reflect your body heat — built for the coldest days.",
    image: IMAGES.thermalSocks,
  },
];
